<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <canvas
        id="myChartFaturamentoVendedoresxMeta"
        width="70"
        height="50"
      />
      <div
        v-if="exibirLegenda"
        id="valorFat"
        class="text-center"
      >
        {{ valorFaturamento }}
      </div>
      <div
        v-if="exibirMeta"
        id="metaId"
      >
        <h4
          class="text-center"
        >
          Valor Meta
        </h4>
        <div
          id="valorMeta"
          class="text-center"
          :style="styleObjectMeta"
        >
          {{ valorMeta }}
        </div>
      </div>
      <div id="textoAlcancadoFat">
        <br>
        <h4
          class="text-center"
        >
          % Alcançado Faturamento
        </h4>
        <h3
          id="valorPorcentagemFat"
          class="text-center"
          :style="styleObjectPorcentagem"
        >
          {{ porcentagem }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardFaturamentoPrecoMedio',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectPorcentagem: {
        color: '#E53935',
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      cores: [],
      myChart: {},
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectVendedor: [],
      selectSupervisor: [],
      exibirLegenda: false,
      exibirMeta: false,
      porcentagem: 0,
      valorMeta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      montarGrafico: true,
      loading: false,
      error: null,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectVendedor, selectResumo, selectMes, selectAno, selectSupervisor) {
        this.selectVendedor = selectVendedor
        this.selectResumo = selectResumo
        this.selectMes = selectMes
        this.selectAno = selectAno
        this.selectSupervisor = selectSupervisor

        this.exibirLegenda = false
        this.exibirMeta = false
        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        this.porcentagem = 0
        this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showGraficoFaturamentoVendedorxMeta(this.selectVendedor, this.selectResumo, this.selectMes, this.selectAno, this.selectSupervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true
            this.exibirMeta = true

            this.porcentagem = resposta.data.porcentagem + '%'

            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorMeta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChartFaturamentoVendedoresxMeta').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.faturamento, resposta.data.meta],
                    backgroundColor: ['#4780b8', '#cadaed'],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChartFaturamentoVendedoresxMeta {
      display: block;
      width: 185px !important;
      height: 128px !important;
      margin: -4rem 0 0 8rem;
    }

    #valorFat {
      font-size: 16px;
      margin: -1.8rem 0 0 2.5rem
    }

    #metaId {
      margin: 2rem 0 0 2rem;
    }

    #valorMeta {
      margin: 0rem 0 0 1rem;
      font-size: 16px;
    }

    #textoAlcancadoFat {
      margin: 0 0 0 3rem;
    }

    #valorPorcentagemFat {
      margin: 0 0 1rem 0rem;
      font-size: 16px;
    }
  }

  @media only screen
  and (min-device-width : 601px)
  and (max-device-width : 1000px) {
    #myChartFaturamentoVendedoresxMeta {
      display: block;
      width: 185px !important;
      height: 128px !important;
      margin: -1rem 0 0 21rem;
    }

    #valorFat {
      font-size: 17px;
      margin: -1.8rem 0 0 -5.9rem
    }

    #metaId {
      margin: 1rem 0 0 -7rem;
    }

    #textoAlcancadoFat {
      margin: 0 0 0 -7rem;
    }
  }

  @media screen
  and (min-width: 1380px) {
    #valorFat {
      margin: -2rem 0 0 0rem;
    }

    #metaId {
      margin: 2rem 0 0rem -1rem;
    }

    #valorMeta {
      margin: 1rem 0 0 0rem;
    }

    #textoAlcancadoFat {
      margin: 0 0 0 -2rem;
    }

    #valorPorcentagemFat {
      margin: 1rem 0 0 0 !important;
    }

    #myChartFaturamentoVendedoresxMeta {
      margin: auto;
    }
  }
</style>

<style lang="sass">
  #myChartFaturamentoVendedoresxMeta
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0 0 0 4rem
    width: 230px !important
    height: 160px !important

  #valorFat
    font-size: 20px
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 4rem

  #metaId
    margin: 2rem 0 0 0

  #valorMeta
    font-size: 20px
    align-items: center
    font-weight: bold
    margin: 1rem 0 0 0

  #valorPorcentagemFat
    margin: 1rem 0 0 1rem
    font-size: 20px
    align-items: center
    font-weight: bold

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
